import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Route from './routes';
import { Toaster } from 'react-hot-toast';
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";
import HistoryContext from "./common/HistoryContext";
import { logout } from './modules/auth/services/authApi';

function App(props) {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const kycVerified = authUser?.user?.kycVerified;

    const location = useLocation();
    const navigate = useNavigate();
    const [path, setPath] = useState([]);

    useEffect(() => {
        setPath((prev) => [...prev, location.pathname]);
    }, [location.pathname]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                const authUser = JSON.parse(sessionStorage.getItem("authUser"));
                const token = authUser?.token;

                if (token && jwtDecode(token).exp < Date.now() / 1000) {
                    logout();
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [navigate]);

    return (
        <HistoryContext.Provider value={path}>
            <React.Fragment>
                <Route />
                <Toaster
                    position="top-center"
                    reverseOrder={false}
                    toastOptions={{
                        duration: 5000, 
                    }}
                />
            </React.Fragment>
        </HistoryContext.Provider>
    );
}

export default App;
